import { AutocompleteFund, AutocompleteItem, AutocompleteSymbol, SearchError } from './entities';
import { StockSymbol } from '@benzinga/session';
import { WidgetLink, isTickerSelectedEvent } from '@benzinga/widget-linking';
import { Watchlist } from '@benzinga/watchlist-manager';

interface BasicSymbolData {
  name: string;
  symbol: StockSymbol;
  type: string;
}

export const createSymbol = <T extends BasicSymbolData>(quote: T): AutocompleteItem => ({
  heading: 'Symbol',
  label: quote.name ? `${quote.symbol} | ${quote.name}` : `${quote.symbol}`,
  name: quote.symbol,
  searchedSymbol: true,
  symbolType: quote.type,
  tagId: quote.symbol,
  type: 'symbol',
});

export const createFund = (fund: AutocompleteFund): AutocompleteItem => ({
  heading: 'Fund',
  label: fund.name,
  name: fund.name,
  tagId: fund.cik.toString(),
  type: 'fund',
});

export const createSymbolLink = (group: WidgetLink): AutocompleteItem => ({
  heading: 'Link',
  label: group.title,
  name: group.events.find(isTickerSelectedEvent)?.symbol ?? '',
  tagId: group.id ?? '',
  type: 'symbolLink',
});

export const createWatchlist = (wl: Watchlist): AutocompleteItem => ({
  name: wl.name,
  tagId: wl.watchlistId,
  type: 'watchlist',
});

export const createError = (searchTerm: string, message: string): SearchError => ({
  message,
  searchTerm,
});

export const calculateSymbolAutocomplete = (serverSymbols: AutocompleteSymbol[] = []): AutocompleteItem[] =>
  serverSymbols.map(createSymbol);

export const calculateFundAutocomplete = (serverFunds: AutocompleteFund[] = []): AutocompleteItem[] =>
  serverFunds.map(createFund);
